<template>

   <transition name="fade" appear>
        <div id="simulation" class="row">
            <h1> Simulation </h1>
            <div>
                <a @click="start" class='btn'> Start </a>
                <a @click="stop" class='btn'> Stop </a>
                <a @click="reset" class='btn'> Reset </a>
            </div>
            
            <div v-scroll>
                <ul id="runners">
                    <li v-for="runner in getActiveRunners()" :key='"runner"+runner.cd_runner'>
                        Equipe: {{runner.cd_runner}} | Speed: {{runner.speed}} | Distance: {{runner.distance}} 
                    </li>
                </ul>
            </div>

        </div>
    </transition>


</template>


<script>

    import along from '@turf/along'

    export default {

        data:function(){
            return {
                activeRunners:[],
                allRunners:[],
                teams:[],
                time:0
             }
        },

        computed:{
            course:function(){
                return this.$store.getters.courses;
            },
        },


        created:function(){

            this.$store.dispatch('loadTeams');


            this.time = new Date().getTime();

            $.getJSON( window.API.tracker+"get_runners", (data)=>{
                this.allRunners = data;
            })

            $.getJSON( window.API.tracker+"get_teams", (data)=>{
                this.teams = data;
            })


               this.interval = setInterval(()=>this.updateRunners(),20000)

        },


        methods:{

            //gera lista de corredores que vou simular, com o pace de cada um
            start:function(){

                var corredoresSelecionados = [];
                
                _.each(this.teams,team=>{
                    let runnerTeam = this.getRunnerForTeam(team);

                    if(runnerTeam){
                        var obj = {
                            "cd_team":team.cd_team,
                            "cd_runner":runnerTeam.cd_runner
                        }
                        obj.team = team;
                        obj.point = [];
                        obj.distance = _.random(0,0);
                        obj.speed = _.random(8.6,25);
                        corredoresSelecionados.push(obj);
                    }
                })

                this.activeRunners = corredoresSelecionados.slice(0,300);

           

            },



            stop:function(){

                clearInterval(this.interval)
            },

            reset:function(){
                this.activeRunners = [];
                $.getJSON(window.API.tracker+"reset_positions",(data)=>{
                    console.log(data);
                })
            },


            getActiveRunners:function(){

                return _.sortBy( this.activeRunners,'distance').reverse()

            },

            getRunnerForTeam:function(team){
                    var runnersEquipe = _.filter(this.allRunners,runner=>runner.cd_team == team.cd_team);
                    return runnersEquipe[Math.floor(Math.random() * (runnersEquipe.length -1))];
            },


            currentTime:function(){
                    var date = new Date()
                    var day = date.getDate();
                    var month = date.getMonth()+1;
                    var year = date.getFullYear();
                    var hours = date.getHours();
                    var min = date.getMinutes();
                    var sec = date.getSeconds();

                    return  `${year}-${month}-${day} ${hours}:${min}:${sec}`;  //"2004-10-19 10:23:54"

            },

            updateRunners:function(){

                    var now = new Date().getTime();
                    var timeDelta = now - this.time;
                    this.time = now;
                    var horaDelta = (timeDelta/1000)/60/60;

                    _.each(this.activeRunners,runner=>{
                        //get actual km
                        var dist = runner.distance

                        runner.speed = _.random(8.6,25);
                        //calculate time passes
                        runner.distance = dist+(runner.speed*horaDelta);
                        // get the new point
                        var point = along(this.course, runner.distance)
                        point = point.geometry.coordinates;
                        runner.point = point;
        
                        var param = {}
                        param.cd_team = runner.cd_team
                        param.cd_runner = runner.cd_runner
                        param.erro = 1
                        param.time = "'"+this.currentTime()+"'";

                        point[0] += _.random(-6/112000,6/112000);
                        point[1] += _.random(-6/112000,6/112000);

                        param.geom = `ST_GeomFromText('POINT(${point[0]} ${point[1]})', 4674)`;

                        debugger;
                        console.log(param);
                        $.ajax({
                            url : window.API.tracker+"push_runner_position",
                            type: "POST",
                            data: JSON.stringify(param),
                            dataType:  "json",
                            contentType: "application/json; charset=utf-8",
                            success: (data)=>{
                                console.log(data);
                                debugger;
                            }
                        });
                    })

            },


        }





    }

</script>

<style lang="stylus" >
    @import "../css/variaveis";

    #simulation{
        position: absolute;
        top: 200px;;
        left: 300px;
        right: 50%;
        height: 100%;
        background:rgba(black,0.2)
        // background: -webkit-linear-gradient(bottom,rgba(0,0,0,0.4), rgba(0,0,0,0));
        padding: 0em 0.5em;
       color:white; 
    }

</style>